import { BUSCAR_OPCOES_FILTROS_EMISSOES_CTE_OS } from '../../actions/types'

const initialState = undefined;
const estadoInicial = {
    veiculos: [],
    naturezasOperacoes: [],
    tomadores: [],
    tipoServico: [],
    responsavelSeguro:[],
    seguro: [],
    tipoFretamento: []
    
}


export default function reducerBuscarOpcoesFiltrosEmissaoesCteOs (state = estadoInicial, action = initialState) {
  switch (action.type) {
    case BUSCAR_OPCOES_FILTROS_EMISSOES_CTE_OS: {
      const opcoesFiltros = action.payload.data;

      if (opcoesFiltros) {
        return opcoesFiltros
      }
      return estadoInicial
    }

    // case LIMPAR_OPCOES_FILTROS_EMISSOES_CTE_OS:
    //   return [];

    default: {
      return state
    }
  }
}
